import request from '../../axios';

export const PatchBannerClickCount = async (bannerGuid: string) => {
  const {data} = await request.patch(
    `/api/v2/store/banners/click/${bannerGuid}`,
  );

  return data;
};
